import { FormProvider } from 'react-hook-form';
import { useCreateTopBannerForm } from './hooks';
import { convertToPresentationProps } from './logics';
import { CreateTopBannerFormPresentation } from './presentations';

/**
 * トップバナー作成フォームのコンテナコンポーネント
 * NOTE: Suspenseを使用するhookを含むため、親コンポーネントでSuspenseでラップしてください
 */
export const CreateTopBannerForm: React.FC = () => {
  const {
    state: { methods, isButtonDisabled, groupsData },
    actions: { handleOnSubmit },
  } = useCreateTopBannerForm();

  const { groupList } = convertToPresentationProps({ groupsData });

  return (
    <FormProvider {...methods}>
      <CreateTopBannerFormPresentation
        groupList={groupList}
        isButtonDisabled={isButtonDisabled}
        onSubmit={handleOnSubmit}
      />
    </FormProvider>
  );
};
